// "Production" enabled environment

export const environment = {
    production: true,
    hmr: false,
    appConfig: 'appconfig.production.json',
    baseUrlHost: 'portal',
    baseUrlTarget: 'https://acc_{TENANCY_NAME}-portal.apprx.eu'
};
